import React from 'react';
import { ContentCourseRepeatRateListService } from '../../services/ContentListService';
import ContentCourseRepeatRateSummary from './ContentCourseRepeatRateSummary';
import { observer } from 'mobx-react';

const ContentCourseRepeatRateSummaryContainer = () => {
  const summary = ContentCourseRepeatRateListService.getChart();
  return (
    <ContentCourseRepeatRateSummary
      isLoading={
        ContentCourseRepeatRateListService.fetchCurrent.fetching ||
        ContentCourseRepeatRateListService.fetchPrevious.fetching
      }
      previousValue={summary.previous}
      currentValue={summary.current}
      formatter={ContentCourseRepeatRateListService.getFormattedValue}
    />
  );
};

export default observer(ContentCourseRepeatRateSummaryContainer);
